import { call, put, all } from "redux-saga/effects";
import { forgottenPasswordAPI } from "../api/ForgottenPasswordCall";
import {
  forgottenPasswordSuccess,
  forgottenPasswordFailure,
} from "../actions/forgottenpasswordactions";
import { reportSuccess, reportError } from "../actions/erroractions";
import { moveToForgottenPageReset } from "../actions/routeactions";

export function* forgottenPasswordSaga(action) {
  try {
    const result = yield call(forgottenPasswordAPI, action);

    if (result.ok) {
      yield all([
        put(forgottenPasswordSuccess()),
        put(moveToForgottenPageReset(action.email, result.securityQuestion)),
        put(reportSuccess("Requested forgotten password")),
      ]);
    } else {
      yield all([
        put(reportError(result.message)),
        put(forgottenPasswordFailure()),
      ]);
    }
  } catch (e) {
    yield all([
      put(reportError("Unable to reach server")),
      put(forgottenPasswordFailure()),
    ]);
  }
}
